import { Category } from "./CategorieList"

interface Props {
  category: Category
  onEdit: (id: number) => void
  onAddChild: (parentId: number) => void
  onDelete: (id: number) => void
}

export function CategoryItem({
  category,
  onEdit,
  onAddChild,
  onDelete,
}: Props) {
  return (
    <li className="border rounded p-4 bg-white">
      <div className="flex justify-between">
        <div>
          <h3 className="font-semibold">{category.name}</h3>
          {category.description && (
            <p className="text-sm text-gray-600">{category.description}</p>
          )}
        </div>

        <div className="flex gap-2">
          <button onClick={() => onEdit(category.id)} className="flex-1 px-3 py-2 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-200 transition-colors">
            Editar
          </button>
          {/* Solo mostrar botón de agregar subcategoría si es categoría padre */}
          {category.parent_id === null && (
            <button onClick={() => onAddChild(category.id)} className="flex-1 px-3 py-2 bg-green-100 text-green-700 rounded-lg text-sm font-medium hover:bg-green-200 transition-colors">
              Agregar Subcategoría
            </button>
          )}
          <button onClick={() => onDelete(category.id)} className="px-3 py-2 bg-red-100 text-red-700 rounded-lg text-sm font-medium hover:bg-red-200 transition-colors">
            Eliminar
          </button>
        </div>
      </div>

      {category.children && category.children.length > 0 && (
        <div className="mt-5">
          <div className="border-b-2 -mb-0.5 ml-10 border-green-600">
            <span className="font-medium text-gray-900">Subcategorías asociadas</span>
          </div>
          <ul className="mt-4 ml-6 space-y-3 pl-4">
            {category.children.map(child => (
              <li key={child.id} className="border rounded p-3 bg-gray-50">
                <div className="flex justify-between items-center">
                  <div>
                    <h4 className="font-medium">{child.name}</h4>
                    {child.description && (
                      <p className="text-sm text-gray-600">{child.description}</p>
                    )}
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => onEdit(child.id)} className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-200">
                      Editar
                    </button>
                    <button onClick={() => onDelete(child.id)} className="px-3 py-1 bg-red-100 text-red-700 rounded-lg text-sm font-medium hover:bg-red-200">
                      Eliminar
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  )
}